import { Injectable } from '@angular/core';
import { StoreSummary } from '../../../classes/models/store/StoreSummary';
import moment from 'moment';
import {
  StoreBankingSettingsResponse,
  StoreClosureResponse,
  StoreDefaultWorkingHoursResponse,
  StoreDetailsResponse,
  StoreEmployeeRequirementsResponse,
  StoreSpecialWorkingHoursResponse,
  StoreSummaryResponse
} from '../../../interfaces/response/StoreResponses';

@Injectable({
  providedIn: 'root',
})
export class TestStoreDataService {

  /** Store summaries response test data. */
  stores: StoreSummaryResponse[] = [
    { slug: '12', name: 'Grantham' },
    { slug: '81', name: 'Huddersfield' },
    { slug: '85', name: 'Hereford' },
    { slug: 'A4', name: 'Tottenham Court' },
    { slug: 'B1', name: 'Longwell Green' },
    { slug: 'B6', name: 'Torquay' },
    { slug: 'C3', name: 'Westfield Stratford' },
    { slug: 'C4', name: 'Christchurch' },
    { slug: 'C5', name: 'Limerick' },
    { slug: 'C8', name: 'Salisbury' },
    { slug: 'D2', name: 'Crawley' },
    { slug: 'D5', name: 'Rugby' },
    { slug: 'D6', name: 'Chelmsford' },
    { slug: 'F3', name: 'Barnstaple' },
    { slug: 'C2', name: 'Oxford' },
    { slug: '01', name: 'Carcroft' },
  ];

  /** Default store working time response test data. */
  defaultStoreWorkingTimes: StoreDefaultWorkingHoursResponse[] = [{
    date: '2020-01-06',
    monday: { openingTime: '08:00:00', closingTime: '20:00:00' },
    tuesday: { openingTime: '09:00:00', closingTime: '21:00:00' },
    wednesday: { openingTime: '09:00:00', closingTime: '21:00:00' },
    thursday: { openingTime: '09:00:00', closingTime: '21:00:00' },
    friday: { openingTime: '09:00:00', closingTime: '21:00:00' },
    saturday: { openingTime: '09:00:00', closingTime: '21:00:00' },
    sunday: { openingTime: '09:00:00', closingTime: '21:00:00' }
  }];

  /** Store special working time response test data. */
  specialStoreWorkingTimes: StoreSpecialWorkingHoursResponse[] = [{
    date: '2020-12-20', workingHours: { openingTime: '08:00:00', closingTime: '21:00:00' }
  }];

  /** Store employee requirements response test data. */
  storeEmployeeRequirements: StoreEmployeeRequirementsResponse[] = [{
    date: '2020-01-06',
    minimumOpeningEmployees: 2,
    minimumRegularEmployees: 3,
    minimumClosingEmployees: 2
  }];

  /** Store banking response test data. */
  storeBanking: StoreBankingSettingsResponse[] = [{
    date: '2020-01-06',
    bankingDays: [1, 3, 5]
  }];

  /** Store closures response test data. */
  storeClosures: StoreClosureResponse[] = [
    { date: '2020-12-25', reason: 'Christmas Day' },
    { date: '2021-01-01', reason: 'New Year\'s Day' }
  ];

  /**
   * Get store details test data.
   * @param store store summary.
   */
  getStoreDetails(store: StoreSummary): StoreDetailsResponse {
    const nextMonday = moment().startOf('week').isoWeekday(1).add(7, 'day').format('YYYY-MM-DD');
    return {
      slug: store.slug,
      name: store.name,
      firstEditableDate: nextMonday,
      defaultWorkingHours: this.defaultStoreWorkingTimes,
      specialWorkingHours: this.specialStoreWorkingTimes,
      employeeRequirements: this.storeEmployeeRequirements,
      bankingSettings: this.storeBanking,
      closures: this.storeClosures
    };
  }
}
